const state = {
  corp_sales_excellence: [],
  corp_sales_excellence_id: [],
};

export default state;
